import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceAll',
})
export class ReplaceAllPipe implements PipeTransform {
  transform(str: string): string {
    return str.replaceAll('"', '');
  }
}
